/**
 * Product finder functionality.
 *
 * @package   product_finder
 * @author    Mark Shercliff <mark@bareface.agency>
 * @copyright 2016 Bareface
 */
;(function($, window, History, undefined) {
    var $productGrid   = $('#product-grid'),
        $productMenu   = $('#product-menu'),
        $productSearch = $('#find-product');

    if (!$productGrid.length || !$productMenu.length || !$productSearch.length) return;

    function ProductFinder($productGrid, $productMenu) {
        var self       = this,
            $overlay   = $('#product-grid-update-overlay'),
            pageNumber = 1;

        self.init = function() {
            $productMenu.find('a[data-function-type="filter"]').not('.disabled').on('click', self.applyFilter);
            $productMenu.find('#reset-filters').on('click', self.reset);
            $productSearch.on('submit', self.applySearch);
            $productGrid.find('.cta--product-grid--load-more').on('click', self.nextPage);

            var categoryId  = $productMenu.find('#product-menu__list').attr('data-category-id'),
                filters     = [],
                queryParams = self.getQueryParams();

            if (categoryId) {
                filters.push(categoryId);
            }

            if (History.getState().data.filters) {
                filters.concat(History.getState().data.filters.split(','));
            } else if (queryParams.filters) {
                filters.concat(queryParams.filters.split(','));
            }

            $.each(filters, function(k, v) {
                $productMenu.find('a[data-function-type="filter"][data-filter-id="' + v + '"]').addClass('active');
            });

            if (History.getState().data.search) {
                $productSearch.find('input[name="search"]').val(History.getState().data.search);
            } else if (queryParams.search) {
                $productSearch.find('input[name="search"]').val(queryParams.search);
            }

            self.getResults();
        };

        self.applyFilter = function() {
            if ($(this).hasClass('disabled')) return;
            $(this).toggleClass('active');
            self.updateLocation();
            self.getResults();
        };

        self.applySearch = function(e) {
            e.preventDefault();
            self.updateLocation();
            self.getResults();
        };

        self.getSearch = function() {
            var search = window.escape($productSearch.find('input[name="search"]').val());

            $productSearch.find('input[name="search"]').val(decodeURI(search));
            return search;
        };

        self.updateLocation = function() {
            var params = {
                filters: self.getFilters(),
                search:  self.getSearch()
            };

            for (var k in params) {
                if (!params[k].length) {
                    delete params[k];
                }
            }

            History.pushState(params, window.document.title, '?' + $.param(params));
        };

        self.nextPage = function(e) {
            e.preventDefault();
            pageNumber += 1;
            self.getResults(pageNumber);
        };

        self.getFilters = function() {
            var filters = $.map($productMenu.find('a[data-function-type="filter"].active'), function(e) {
                return $(e).attr('data-filter-id');
            });
            return filters.join(',');
        };

        self.reset = function() {
            $productMenu.find('a[data-function-type="filter"]').removeClass('active');
            $productSearch.find('input[name="search"]').val('');
            History.pushState({}, window.document.title, '?');
            self.getResults();
        };

        self.getResults = function(pageNumber) {
            self.showOverlay(self.closeMenu);

            $.ajax({
                url:      window.ajaxurl,
                type:     'get',
                dataType: 'json',
                data:     {
                    action:  'product_finder_data',
                    filters: self.getFilters(),
                    search:  self.getSearch(),
                    page:    pageNumber
                }
            }).success(function(response) {
                if (!pageNumber) {
                    $productGrid.find('.product-list').html(response.template);
                } else {
                    $productGrid.find('.product-list').append(response.template);
                }
                $productGrid.find('.cta--product-grid--load-more').toggle(response.more);
                self.updateFilters(response.filters);
                if (self.getSearch() == '') {
                    self.hideOverlay();
                } else {
                    self.hideOverlay(self.scrollToResults);
                }
            });
        };

        self.closeMenu = function() {
            if ($productMenu.hasClass('visible')) {
                $productMenu.find('a[data-function-type="menu"]').trigger('click');
            }
        };

        self.showOverlay = function(f) {
            $('body').addClass('has-overlay');
            $overlay.fadeIn(f);
        };

        self.hideOverlay = function(f) {
            $('body').removeClass('has-overlay');
            if (f === undefined) {
                $overlay.fadeOut();
            } else {
                $overlay.fadeOut(f);
            }
        };

        self.scrollToResults = function() {
            $('body, html').animate({
                scrollTop: $productGrid.offset().top - 200
            }, 300);
        };

        self.updateFilters = function(filters) {
            var $filters = $productMenu.find('a[data-function-type="filter"]'),
                _filters = [];

            $.each(Object.keys(filters), function(_, k) {
                $.each(filters[k], function(_, v) {
                    _filters.push(v.filter_id);
                });
            });

            $filters.each(function() {
                $(this).toggleClass('disabled', _filters.indexOf(parseInt($(this).attr('data-filter-id'))) === -1);
            });

            $productMenu.find('.product-menu__list--inner').each(function() {
                var $children = $(this).children();
                $children.detach();
                $children.sort(function(a, b) {
                    var compare = $(a).find('a[data-function-type="filter"].disabled').length - $(b).find('a[data-function-type="filter"].disabled').length;
                    if (0 !== compare) {
                        return compare;
                    }
                    return $(a).find('a[data-function-type="filter"]').text().localeCompare($(b).find('a[data-function-type="filter"]').text());
                });
                $(this).append($children);
            });
        };

        self.getQueryParams = function(str) {
            return (str || window.location.search).replace(/(^\?)/,'').split("&").map(function(n){return n = n.split("="),this[n[0]] = n[1],this}.bind({}))[0];
        };

        self.init();
    };

    var productFinder = new ProductFinder($productGrid, $productMenu);
})(jQuery, window, History);
